import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'

export default function getRootEntityTypeByPageType(pageType: PageTypeEnum) {
  switch (pageType) {
    case PageTypeEnum.Inline:
      return [EntityTypeEnum.InlineBody]
    case PageTypeEnum.Popup:
      return [EntityTypeEnum.RemotePopupBody]
    case PageTypeEnum.BlogPostLayout:
      return [EntityTypeEnum.BlogPostLayoutBody]
    case PageTypeEnum.WebsiteHome:
    case PageTypeEnum.WebsiteDefault:
    case PageTypeEnum.WebsitePricing:
    case PageTypeEnum.WebsiteSearch:
      return [EntityTypeEnum.WebsiteLayoutBody]
    case PageTypeEnum.WebsiteLogin:
      return [EntityTypeEnum.WebsitePageBody]
    default:
      return [EntityTypeEnum.Body]
  }
}
